import api from 'api'

export type GenerateInvoicesRequest = {
  companyId: number
  startsAt: string
  endsAt: string
}

export type GeneratedInvoice = {
  companyId: number
  invoiceId: number
}

export type GenerateInvoicesResponse = {
  invoices: GeneratedInvoice[]
}

export async function generateInvoices(
  request: GenerateInvoicesRequest
): Promise<GenerateInvoicesResponse> {
  const response = await api.post<GenerateInvoicesResponse>(
    '/admin/charges/invoices',
    {
      companyId: request.companyId,
      startsAt: request.startsAt,
      endsAt: request.endsAt,
    }
  )
  return response.data
}
